export default __webpack_public_path__ + "static/media/icon-locations.5211d792.svg";